import React from 'react';
export function Closing() {
  return <section className="w-full bg-transparent py-8" data-id="element-15" data-mp="133xgy8p19d0b">
      <div className="max-w-4xl mx-auto px-4 md:px-6" data-id="element-16" data-mp="3t1aovawlr7v7">
        <div className="bg-[#C084FC] text-white p-6 md:p-8 rounded-lg relative overflow-hidden" data-id="element-17" data-mp="3t2vkz4ykeyv6">
          <h2 className="text-3xl md:text-4xl font-bold mb-4 text-center" data-id="element-18" data-mp="3f7a099zd718k">
            El próximo domingo...
          </h2>
          <div className="space-y-3 text-lg leading-relaxed" data-id="element-19" data-mp="35b6p5emjbs9h">
            <p data-id="element-20" data-mp="359lvrsbyifd7">
              El próximo domingo podés estar como siempre: buscando actividades
              a último momento, armando material con lo que encontrás, llegando
              al lunes con la planificación a medio hacer...
            </p>
            <p className="font-semibold" data-id="element-21" data-mp="30bk8swbetvwg">O podés tener TODO tu año resuelto.</p>
            <p data-id="element-22" data-mp="uj5fymkz6ydq">
              Cada semana planificada.
              <br data-id="element-23" data-mp="ujnanerzp4jj" />
              Cada actividad secuenciada.
              <br data-id="element-24" data-mp="yl8tdgr7gd1n" />
              Cada rúbrica lista.
              <br data-id="element-25" data-mp="yjxotepxr19h" />
              Cada informe con plantilla.
            </p>
            <p className="text-2xl font-bold text-center pt-6" data-id="element-26" data-mp="3r0o0fnt28x2z">Vos elegís.</p>
          </div>
        </div>
      </div>
    </section>;
}